import { FIELD_PATHS } from '@funnels/constants';
import { IncomeEntityIndex } from '@funnels/types';

import { TextAreaField } from '../../Fields';

interface IncomeCommentProps extends IncomeEntityIndex {
  label?: string;
  isForAddBack?: boolean;
  isForDeduction?: boolean;
  isDisabled?: boolean;
  isOptional?: boolean;
}

export const IncomeComment = (props: IncomeCommentProps) => {
  const { incomeIndex, label, isForAddBack = false, isForDeduction = false, ...rest } = props;
  const path = isForAddBack
    ? FIELD_PATHS.INCOME_BUSINESS_ADDBACK_COMMENTS(incomeIndex)
    : isForDeduction
    ? FIELD_PATHS.INCOME_BUSINESS_DEDUCTION_COMMENTS(incomeIndex)
    : FIELD_PATHS.INCOME_COMMENTS(incomeIndex);

  return <TextAreaField label={label} name={path} isFullWidth {...rest} />;
};
